<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='9'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <!--右侧开始-->
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">我的订单</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <router-link :to="{path:'/Address'}">我的收货地址</router-link>
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <div class="cght_ddgltop">
              <ul class="cght_ddglnavula">
                <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.filters.state == null}" @click="changeState()">全部订单</a></li>
                <!-- <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.orderType == 2}">待付款 <em>1</em></a></li> -->
                <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.filters.state == 0}" @click="changeState(0)">待发货<em></em></a></li>
                <li><a href="javascript:;" :class="{cght_ddglnavulaxz:listQuery.filters.state == 1}" @click="changeState(1)">待收货 <em></em></a></li>
              </ul>
              <div class="cght_ddglright">
                <!-- <div class="cght_ddglrightl"><a href="__ROOT__/Member/ddhsz">我的订单回收站</a></div>选中cght_ddglrightlxz -->
                <div class="cght_ddglrightr"><div><em><input type="text" class="cght_inputtextsh" ddkeywords/></em><a href="javascript:;" ddsearch></a></div></div>
              </div>
            </div>
            <div class="cght_table_boxhie" v-loading="qyloading">
              <!-- 申购单 -->
              <table class="cght_ddtable" v-for="(item, index) in list" :key="index" width="990" cellspacing="0" cellpadding="0">
                <tr class="cght_ddtabletb">
                  <td colspan="6">
                    <div class="cght_ddtablesj">{{item.create_time}}</div>
                    <div class="cght_ddtableddh">订单号：<em>{{item.order_id}}</em></div>
                    <div class="cght_ddtablesl" style="width: 103px;">数量</div>
                    <div class="cght_ddtablesl" style="width: 170px;">价格</div>
                    <div class="cght_ddtablesc" v-if="item.is_buy===0" @click="delPreOrder(item.order_id)"><i class="iconfont cght_scddqdshowtc">&#xe611;</i></div>
                    <div class="cght_ddtablesl" style="width: 270px;">规格</div>
                  </td>
                </tr>
                <tr v-for="(goods, i) in item.detail" :key="i">
                  <td width="465" class="cght_ddtablexxnrabox">
                    <div class="cght_ddtablexxnra">
                      <router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}">
                        <img v-real-img="goods.imgpath" src="../../assets/images/zwtp.jpg" :alt="goods.title" width="60" height="60" />
                      </router-link>
                    </div>
                    <div class="cght_ddtablexxnrb">
                      <h3><router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}" target="_blank">{{goods.title}}</router-link></h3>
                    </div>
                    <div class="cght_ddtablexxnrc" style="width:90px;">x{{goods.number}}</div>
                    <!--<div class="cght_ddtablexxnrd"><a href="javascript:;">退货</a></div>-->
                  </td>
                  <td rowspan="" width="80" class="cght_ddtableshrm"><div class="cght_ddtableje4">￥{{goods.tax_price}}</div></td>
                  <td rowspan="" width="110">
                    <div class="cght_ddtableje5">￥{{(goods.tax_price*goods.number).toFixed(2)}}</div>
                    <div class="cght_ddtableje4"><a>{{goods.plant_sku || goods.sku}}</a></div>
                  </td>
                  <td colspan="2">
                    <el-tag size="mini" style="margin-left:10px;" v-for="(ie,i) in goods.specParamList" :key="i">{{ie.param_name}}：{{ie.option_value}}</el-tag>
                  </td>
                  <td rowspan="" width="80" class="cght_ddtableshrm">
                    <el-button class="action-item" icon="el-icon-delete" v-if="goods.is_buy===0" size="mini" @click="delOrderGoods(goods)">删除</el-button>
                    <span v-if="goods.is_buy === 0">未采购</span>
                    <span v-else>已采购</span>
                  </td>
                </tr>
              </table>
              <div class="cght_meiyoudingdansc" v-if="list.length==0">
                <div class="cght_meiyoudingdanscd">
                  <em>您还没有申购单哦~</em>
                  <router-link :to="{path:'/'}" class="cght_meiyoudingdanscda">去首页看看</router-link>
                </div>
              </div>
              <!-- <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/order'

export default {
  name: 'MyPreOrder',
  components: { Top, LeftNav, Bottom, Pagination },
  data () {
    return {
      api,
      qyloading: false,
      listQuery: {
        limit: 30,
        order: 'create_time',
        filters: {
        }
      },
      list: [],
      orderIdList: []
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.LoadData()
  },
  methods: {
    LoadData () {
      this.qyloading = true
      api.myPreOrderList(this.listQuery).then(res => {
        let newlist = res.items
        newlist.forEach(element => {
          element.detail.forEach(response => {
            if (response.specParamList) {
              response.specParamList = JSON.parse(response.specParamList)
            }
          })
          this.orderIdList.push(element.order_id)
        })
        this.list = newlist
        this.qyloading = false
      })
    },
    changeState (state) {
      if (state === undefined) {
        this.listQuery.filters = {}
      } else {
        this.listQuery.filters = {state}
      }
      this.listQuery.page = 1
      this.LoadData()
    },
    delPreOrder (orderId) {
      this.$confirm('确定删除该申购单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delPreOrder({orderId: orderId}).then(res => {
          this.listQuery.page = 1
          this.LoadData()
        })
      }).catch(() => {})
    },
    delOrderGoods (goods) {
      this.$confirm('确定删除该申购产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delOrderGoods({goods_id: goods.goods_id, order_id: goods.order_id}).then(res => {
          this.listQuery.page = 1
          this.LoadData()
        })
      }).catch(() => {})
    }
  }
}
</script>
<style scoped>
  .cght_meiyoudingdansc{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/view/member/preorder.vue